import { Button, Stack } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useBillingDemo } from './useBillingDemo';
import BillingDemoPanel from './BillingDemoPanel';
export default function SubscriptionDemo() {
  const { teamSlug = '' } = useParams<{ teamSlug: string }>();
  const resource = useBillingDemo(teamSlug);
  const base = `/a/${teamSlug}/subscription`;
  return (
    <Stack spacing={3}>
      <BillingDemoPanel
        title="Subscription Demo"
        data={resource.data}
        loading={resource.loading}
        error={resource.error}
        onRetry={resource.retry}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} useFlexGap flexWrap="wrap" gap={2}>
        <Button component={RouterLink} to={`${base}/subscription-gated-page`} variant="outlined">
          Check subscription access
        </Button>
        <Button component={RouterLink} to={`${base}/metered-billing-demo`} variant="outlined">
          Metered usage
        </Button>
        <Button component={RouterLink} to={base}>
          View billing
        </Button>
      </Stack>
    </Stack>
  );
}
